import Move1 from "../../assets/capabilities/move/OmniSmallPlumeNoSound.mp4";
import Move1Poster from "../../assets/capabilities/move/omnivore-poster.png";

import Processing1 from "../../assets/capabilities/process/process-1.png";
import Processing2 from "../../assets/capabilities/process/process-4.gif";
import Processing3 from "../../assets/capabilities/process/process-3.png";

import React from "react";

export const rndData = {
  moving: {
    title: "Omnivore™ Solar Thermal Propulsion",
    cardsPosition: "bottom",
    titleAbove: true,
    heroCards: [
      {
        title: "Radical Mobility Approach",
        description: "Revolutionary in-space mobility powered by concentrated sunlight",
      },
      {
        title: "Solar Thermal Propulsion",
        description: "Powerful and practical propulsion system using simple solar concentration",
      },
      {
        title: "Efficient Power Generation",
        description: "Clean, renewable power for long-duration space operations",
      },
    ],
    content: [
      {
        title: "Omnivore",
        cards: [
          {
            description: "Solar thermal propulsion rivals nuclear rocket performance",
          },
          {
            description: "Fraction of the cost without major safety issues",
          },
        ],
        href: Move1,
        poster: Move1Poster,
        tiltShift: true,
      },
    ],
  },
  processing: {
    title: "Optical Mining™",
    titleAbove: true,
    cardsPosition: "bottom",
    heroCards: [
      {
        title: "What It Is",
        description: "Revolutionary process that uses concentrated sunlight to extract resources without consumable chemicals or mechanical drilling",
      },
      {
        title: "Applications",
        description: "Enables asteroid mining, space debris recycling, and in-space manufacturing with $100B near-term commercial potential",
      },
      {
        title: "Demonstrated Technology",
        description: "Successfully demonstrated by TransAstra using concentrated sunlight to achieve spallation from synthetic asteroid with a 1 meter reflector",
      },
    ],
    content: [
      {
        href: Processing2,
      },
      {
        title: "Solar Forge™",
        cardsPosition: "bottom",
        cards: [
          {
            description: "Scalable solar-thermal materials processing station uses concentrated sunlight for materials processing without consumable chemicals",
          },
          {
            description: "Pioneering Vapor-Phase Fractional Distillation (VFD) and Quantum Spin Separation (QSS) for precision metal separation in vacuum",
          },
          {
            description: "Enables sustainable asteroid mining, space debris recycling, and in-space manufacturing at industrial scales",
          },
        ],
        href: Processing3,
      },
    ],
  },
};

